import {data} from "../api/data";
import {auth} from "./auth";

export const API = {
	auth,
	data
};